export default "__VITE_ASSET__CuKu7jwV__"